import IconCalendar from '../../../Icons/Calendar';
import IconClock from '../../../Icons/Clock';
import IconQRCode from '../../../Icons/QRCode';

const Boleto = () => {

  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-2'>
        <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
          <div className='min-h-8'>
            <IconClock className='text-green-700' />
          </div>
          <p className='text-black font-medium leading-tight'>Pague até a data de vencimento</p>
          <p className='text-sm text-gray-500'>Pague até o vencimento para garantir acesso ao produto.</p>
        </div>

        <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
          <div className='min-h-8'>
            <IconCalendar className='text-green-700' />
          </div>
          <p className='text-black font-medium leading-tight'>Aguarde a aprovação do pagamento</p>
          <p className='text-sm text-gray-500'>Boletos podem leva <span className="font-medium">até 3 dias úteis</span> para serem compensados.</p>
        </div>

        <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
          <div className='min-h-8'>
            <IconQRCode className='text-green-700' />
          </div>
          <p className='text-black font-medium leading-tight'>Pague com Pix e tenha acesso imediato</p>
          <p className='text-sm text-gray-500'>Pagamentos são processados em alguns segundos.</p>
        </div>
      </div>
    </>
  );
};

export default Boleto;
